<template>
    <div class="main">
        <p class="title">Mycard點卡</p>
        <div class="money">
            <div class="m-title">點卡金額</div>
            <div class="m-list">
                <div v-for="item in money" class="list-item" :class="activeM==item.id?'active' : ''" :key="item.id" @click="moneyChoose(item.id,item.num)">{{item.num}} USD</div>
            </div>
            <div class="m-listI mt100">
                <input type="number" v-model="setMoney" class="list-item" />
                <span>= {{changeM}} Mycard 點數</span>
            </div>
        </div>
        <div class="bank">
            <div class="m-title">選擇支付方式</div>
            <div class="b-list">
                <div v-for="item in bank" class="list-item" :class="activeB==item.id?'active' : ''" :key="item.id" @click="bankChoose(item.id)">{{item.name}}</div>
            </div>
            <div class="m-list mt80">
                <div class="cheakin" @click="showMask">立即購買</div>
            </div>
        </div>
        <common-mask v-if="isMask" @closeMask="closeMask"></common-mask>
    </div>
</template>
<script>
import CommonMask from '@/components/mask'
export default {
    data() {
        return {
            money: [
                {
                    id: '1',
                    num: 10,
                },
                {
                    id: '2',
                    num: 20,
                },
                {
                    id: '3',
                    num: 30,
                },
                {
                    id: '4',
                    num: 50,
                },
                {
                    id: '5',
                    num: 100,
                },
                {
                    id: '6',
                    num: 200,
                },
                {
                    id: '7',
                    num: 300,
                },
                {
                    id: '8',
                    num: 500,
                },
                {
                    id: '9',
                    num: 1000,
                },
            ],
            bank: [
                {
                    id: '1',
                    name: 'Paypal',
                },
                {
                    id: '2',
                    name: '支付寶',
                },
                {
                    id: '3',
                    name: 'VISA',
                }
            ],
            setMoney: 10,
            setBank: '',
            activeM: '1',
            activeB: '1',
            isMask: false
        }
    },
    components:{CommonMask},
    computed: {
        changeM: function () {
            return this.setMoney * 1
        },
    },
    mounted: function () {},
    methods: {
        moneyChoose: function (e, a) {
            this.activeM = e
            this.setMoney = a
        },
        bankChoose: function (e) {
            this.activeB = e
        },
        showMask() {
            this.isMask = true;
        },
        closeMask() {
            this.isMask = false;
        }
    }
}
</script>
<style lang="css" scoped>
input {
    outline: 0;
    text-align: center;
}
.mt100 {
    margin-top: 50px !important;
}
.mt80 {
    margin-top: 80px;
    padding-bottom: 100px;
}
.main {
    width: 100%;
    position: relative;
    top: 0;
    padding-top: 150px;
    background-color: #f3f4f2;
}
.title {
    color: #ef653d;
    font-weight: 600;
    font-size: 40px;
    /**letter-spacing: 5px**/
}
.money,
.bank {
    width: 1200px;
    margin: 0 auto;
    border-bottom: 2px solid #ef653d;
}
.bank {
    border-bottom: 0;
}
.m-title {
    color: #333;
    font-size: 25px;
    padding: 50px;
    text-align: left;
}
.m-listI {
    width: 700px;
    margin: 0 auto;
    display: flex;
    flex-flow: row wrap;
    justify-content: start;
    line-height: 30px;
}
.m-list,
.b-list {
    width: 700px;
    margin: 0 auto;
    display: flex;
    flex-flow: row wrap;
    justify-content: space-between;
}
.b-list {
    justify-content: flex-start;
}
.b-list .list-item {
    margin-right: 30px;
}
.list-item {
    border: 1px solid #666;
    border-radius: 10px;
    font-size: 15px;
    padding: 7px 0px;
    width: 150px;
    margin-bottom: 50px;
    cursor: pointer;
}
.cheakin {
    border-radius: 10px;
    font-size: 15px;
    padding: 7px 0px;
    width: 150px;
    margin-bottom: 50px;
    cursor: pointer;
    color: white;
    background-color: #ef653d;
}
.m-list .active,
.b-list .active {
    border: 1px solid #ef653d;
    color: #ef653d;
}
.m-listI span {
    font-size: 23px;
    display: inline-block;
    margin-left: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/voucher.vue